import React from "react";

import {
  IFluid,
  ILocalFile
} from "../../types/local-files";
import TestimonialCarousel from "../testimonial-carousel";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

export interface IParagraphTestimonial {
  field_testimonial: string;
  field_testimonial_name: string;
  field_testimonial_role: string;
  field_testimonial_company: string;
  relationships?: {
    field_testimonial_company_logo?: ILocalFile<IFluid>;
  };
}

const ParagraphBoxOutTestimonials = ({ content }: IProps) => {
  const rel = content.relationships || null;
  const testimonials = rel ? rel.field_testimonial_item : null;

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  return (
    <TestimonialCarousel
      className="paragraph-box-out-testimonials"
      content={testimonials.map((testimonial: IParagraphTestimonial) => {
        const tRel = testimonial.relationships || null;
        const logo = tRel ? tRel.field_testimonial_company_logo : null;

        const src =
          logo &&
          logo.localFile.childImageSharp &&
          logo.localFile.childImageSharp.fluid ?
            logo.localFile.childImageSharp.fluid.src :
            undefined;

        return {
          testimonial: testimonial.field_testimonial,
          name: testimonial.field_testimonial_name,
          role: testimonial.field_testimonial_role,
          company: testimonial.field_testimonial_company,
          company_logo: src
        };
      })}
    />
  );
};

export default ParagraphBoxOutTestimonials;
